<script setup lang="ts">
definePageMeta({
  layout: false,
})

onMounted(() => {
  const ua = navigator.userAgent
  const isWebView = /(?:iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua) || /\bwv\b/i.test(ua)

  if (!isWebView) {
    setTimeout(() => {
      window.open('', '_self', '')
      window.close()

      setTimeout(() => {
        navigateTo('/dashboard')
      }, 500)
    }, 5000)
  }
})
</script>

<template>
  <div class="min-h-svh bg-[#f0f0f0] flex items-center justify-center px-6">
    <Card class="w-full max-w-sm flex flex-col items-center gap-6 text-center py-8">
      <!-- Logo -->
      <img src="/rintisan.png" alt="Rintisan" class="h-8 object-contain">

      <!-- Spinner -->
      <div class="animate-spin rounded-full size-16 border-4 border-neutral-200 border-b-primary" />

      <!-- Text -->
      <div class="space-y-1.5">
        <h1 class="font-bold">
          Memproses transaksi...
        </h1>
        <p class="text-sm leading-relaxed">
          Sistem sedang mengecek status transaksi kamu. Harap tunggu sebentar.
        </p>
      </div>

      <!-- Auto close info -->
      <div class="space-y-2 pt-6">
        <p class="text-sm leading-relaxed">
          Halaman ini akan menutup otomatis. Atau tutup halaman ini secara manual
        </p>
        <!-- class="text-sm font-medium gradient-text underline underline-offset-2" -->
      </div>
    </Card>
  </div>
</template>
